module.exports = __webpack_public_path__ + "5a3e26c98d8f2862e2a4e7f39cad3652.png";